/* eslint-disable prettier/prettier */ 'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BUSINESS_BOOKER_USER_ROLES } from '@whitbread-eos/api';
import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@whitbread-eos/atoms/ui';
import { getPathForLocale, useGetCountryLanguage } from '@whitbread-eos/utils';
import { getInitials, RolesRequired, useTranslation, formatIBAssetsUrl, getLocaleByPathname, cn } from '@whitbread-eos/utils/server';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import { BusinessSteps } from './BusinessSteps';
import LanguageMenu from './LanguageMenu';
import Search from './Search';
const Header = ({ logoUrl, companyLabel, accountName, languages, userRole = '', searchFormLabels = {}, icons, globalLabels, businessStepType, hideEditSearch = ()=>{
    return;
}, isEditSearchVisible, logoOnly })=>{
    const pathname = usePathname();
    const locale = getLocaleByPathname(pathname);
    const { language } = useGetCountryLanguage();
    const { t } = useTranslation();
    const { firstName, lastName } = accountName;
    const accountInitials = getInitials(firstName, lastName);
    const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
    const renderSearch = ()=>{
        return /*#__PURE__*/ _jsx(RolesRequired, {
            userRole: userRole,
            requiredRoles: [
                BUSINESS_BOOKER_USER_ROLES.SUPER,
                BUSINESS_BOOKER_USER_ROLES.BOOKER,
                BUSINESS_BOOKER_USER_ROLES.SELF
            ],
            children: /*#__PURE__*/ _jsx(Search, {
                formLabels: searchFormLabels,
                locale: locale,
                language: language,
                addRoomIcon: formatIBAssetsUrl(globalLabels === null || globalLabels === void 0 ? void 0 : globalLabels.addRoomIcon),
                icons: icons,
                userRole: userRole,
                globalLabels: globalLabels,
                hideEditSearch: hideEditSearch
            })
        });
    };
    const renderUserDetails = ()=>{
        var _languages_find, _languages_find1;
        var _languages_find_flagUrl, _languages_find_flagUrl1;
        return /*#__PURE__*/ _jsxs("div", {
            className: rightContainerStyle,
            children: [
                /*#__PURE__*/ _jsx("h1", {
                    className: companyLabelStyle,
                    "data-testid": "Company-Name",
                    children: companyLabel
                }),
                /*#__PURE__*/ _jsx(LanguageMenu, {
                    languages: languages,
                    language: language,
                    enIcon: formatIBAssetsUrl((_languages_find_flagUrl = languages === null || languages === void 0 ? void 0 : (_languages_find = languages.find((lang)=>{
                        var _lang_code;
                        return (lang === null || lang === void 0 ? void 0 : (_lang_code = lang.code) === null || _lang_code === void 0 ? void 0 : _lang_code.toLowerCase()) === 'gb';
                    })) === null || _languages_find === void 0 ? void 0 : _languages_find.flagUrl) !== null && _languages_find_flagUrl !== void 0 ? _languages_find_flagUrl : ''),
                    deIcon: formatIBAssetsUrl((_languages_find_flagUrl1 = languages === null || languages === void 0 ? void 0 : (_languages_find1 = languages.find((lang)=>{
                        var _lang_code;
                        return (lang === null || lang === void 0 ? void 0 : (_lang_code = lang.code) === null || _lang_code === void 0 ? void 0 : _lang_code.toLowerCase()) === 'de';
                    })) === null || _languages_find1 === void 0 ? void 0 : _languages_find1.flagUrl) !== null && _languages_find_flagUrl1 !== void 0 ? _languages_find_flagUrl1 : '')
                }),
                /*#__PURE__*/ _jsxs(DropdownMenu, {
                    children: [
                        /*#__PURE__*/ _jsx(DropdownMenuTrigger, {
                            asChild: true,
                            children: /*#__PURE__*/ _jsx(Button, {
                                variant: "secondary",
                                className: profileButtonStyle,
                                "data-testid": "Account-Menu-Button",
                                children: accountInitials
                            })
                        }),
                        /*#__PURE__*/ _jsxs(DropdownMenuContent, {
                            className: profileDropdownStyle,
                            align: "end",
                            avoidCollisions: false,
                            "data-testid": "Account-Menu-Dropdown",
                            children: [
                                /*#__PURE__*/ _jsx(Link, {
                                    href: getPathForLocale(locale, 'profile'),
                                    className: "block text-base px-4 py-2.5 hover:bg-lightGrey5",
                                    "data-testid": "Account-Profile-Link",
                                    children: t('content.authentication.myProfile')
                                }),
                                /*#__PURE__*/ _jsx(Link, {
                                    href: "/logout",
                                    className: "block text-base px-4 py-2.5 hover:bg-lightGrey5",
                                    "data-testid": "Account-Logout-Link",
                                    children: t('content.authentication.logoutButton')
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const renderSearchMobile = ()=>{
        return !isEditSearchVisible && /*#__PURE__*/ _jsx(RolesRequired, {
            userRole: userRole,
            requiredRoles: [
                BUSINESS_BOOKER_USER_ROLES.SUPER,
                BUSINESS_BOOKER_USER_ROLES.BOOKER,
                BUSINESS_BOOKER_USER_ROLES.SELF
            ],
            children: /*#__PURE__*/ _jsx(Search, {
                mobile: true,
                formLabels: searchFormLabels,
                locale: locale,
                language: language,
                icons: icons,
                addRoomIcon: formatIBAssetsUrl(globalLabels === null || globalLabels === void 0 ? void 0 : globalLabels.addRoomIcon),
                userRole: userRole,
                globalLabels: globalLabels,
                hideEditSearch: hideEditSearch,
                onOpenChange: (open)=>setMobileSearchOpen(open)
            })
        });
    };
    return /*#__PURE__*/ _jsxs("header", {
        className: cn(headerStyle, mobileSearchOpen ? headerSearchOpenStyle : ''),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: cn(headerContainerStyle, businessStepType ? businessStepStyle : ''),
                children: [
                    /*#__PURE__*/ _jsx(Link, {
                        href: getPathForLocale(locale, 'homepage'),
                        "data-testid": "IB-Logo",
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: logoUrl,
                            alt: t('content.header.imageAlt'),
                            className: logoStyle,
                            width: 160,
                            height: 48
                        })
                    }),
                    !logoOnly && (businessStepType ? /*#__PURE__*/ _jsx(BusinessSteps, {
                        type: businessStepType
                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            renderSearch(),
                            renderUserDetails()
                        ]
                    }))
                ]
            }),
            !businessStepType && renderSearchMobile()
        ]
    });
};
export default Header;
const logoStyle = 'w-40 h-12 max-w-none';
const headerStyle = 'fixed mobile:static top-0 flex flex-col justify-center px-[4.125rem] py-4 border-b border-lightGrey3 h-headerHeight w-full bg-background mobile:h-auto mobile:px-4 z-40';
const headerSearchOpenStyle = 'mobile:fixed';
const headerContainerStyle = 'flex items-center justify-between';
const businessStepStyle = 'mobile:flex-col mobile:items-start';
const rightContainerStyle = 'flex justify-end gap-4 items-center w-[30%] mobile:w-full';
const companyLabelStyle = 'text-lg leading-6 font-medium mobile:hidden tablet:w-[9.375rem] tablet:line-clamp-2';
const profileButtonStyle = 'focus-visible:ring-0 p-0 focus-visible:ring-offset-0 rounded-full w-11 h-11 bg-lightGrey5 rounded-full hover:bg-initial text-base text-darkGrey1 font-semibold shrink-0';
const profileDropdownStyle = 'w-[12.5rem] shadow p-0 box-border border-lightGrey3 rounded';
